export default __webpack_public_path__ + "static/media/graph.d22c314e.jpg";